//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { BookingPriceOverrideItem } from './BookingPriceOverrideItem';
import { WebsiteBlockSignupFormAdditionalFieldsInputItem } from './WebsiteBlockSignupFormAdditionalFieldsInputItem';
import { WebsiteCustomFieldSignupFormInputItem } from './WebsiteCustomFieldSignupFormInputItem';
import { WebsiteBlockUpdateItem } from './WebsiteBlockUpdateItem';
import { StudentStatus, StudentTypes, SignupPaymentType, WebsiteBlockSignupFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockSignupFormUpdateItem extends WebsiteBlockUpdateItem {
    Header?: string | null;
    DefaultStudentStatus?: StudentStatus;
    AllowedStudentTypes?: StudentTypes;
    TagIDs?: string[];
    TeacherIDs?: string[];
    EventCategoryIDs?: string[];
    PaymentType?: SignupPaymentType | null;
    RegistrationFeeAmount?: number | null;
    RegistrationFeeDescription?: string | null;
    RegistrationFeeChargeCategoryID?: string | null;
    DepositAmount?: number | null;
    HoldTimeSlot?: boolean;
    BookingPriceOverride?: BookingPriceOverrideItem | null;
    SendLoginInformation?: boolean;
    SendConfirmationEmail?: boolean;
    EmailTemplateSubject?: string | null;
    EmailTemplateBody?: string | null;
    ThankYouMessage?: string | null;
    SignupFormType?: WebsiteBlockSignupFormType;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.SignupForm;
    AdditionalFields?: WebsiteBlockSignupFormAdditionalFieldsInputItem | null;
    CustomFields?: WebsiteCustomFieldSignupFormInputItem[];

    constructor(initializer?: Partial<Omit<WebsiteBlockSignupFormUpdateItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockSignupFormUpdateItem";
}
